import clsx from "clsx"
import React from "react"
import { NavLink, useLocation } from "react-router-dom"

import CitationBadge, {
  CitationDetails,
} from "@pages/launch-solutions/SolutionTabsContainer/components/Tabs/FactFinder/components/SourceView/components/ImageResult/AnswerOriginalView/components/CitationBadge"

import styles from "./MarkdownNavLink.module.sass"

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode & React.ReactNode[]
  text?: string
}

const MarkdownNavLink = React.forwardRef<HTMLAnchorElement, Props>(
  ({ href = "/", className, children, text, ...restProps }, ref) => {
    const location = useLocation()

    const citation = isValidCitationKey(text)

    return (
      <NavLink
        ref={ref}
        to={href}
        {...restProps}
        target={citation ? undefined : "_blank"}
        className={clsx(className, {
          [styles.citation]: citation,
        })}
        state={{ backTo: location.pathname }}
      >
        {citation ? (
          <CitationDetails
            citationNumber={Number(text?.split("_")?.at(0))}
            citationId={text}
          >
            <CitationBadge citationNumber={Number(text?.split("_")?.at(0))} />
          </CitationDetails>
        ) : (
          children
        )}
      </NavLink>
    )
  }
)

export default MarkdownNavLink

const isValidCitationKey = (children: React.ReactNode): children is string => {
  if (typeof children !== "string") return false
  const [index, subIndex] = children.split("_")
  return (
    index != null &&
    !Number.isNaN(Number(index)) &&
    subIndex != null &&
    !Number.isNaN(Number(subIndex))
  )
}
